import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import ResponsiveTooltip from 'components/ResponsiveTooltip';
import styles from './style.module.less';
const IconButton = ({ tooltip, children, disabled, danger, onClick, className, tooltipPlacement = 'left', style, id, }) => {
    return (_jsx(ResponsiveTooltip, { title: tooltip, placement: tooltipPlacement, children: _jsx("button", { type: "button", id: id, className: clsx(styles.iconButton, className, { [styles.iconButtonDanger]: danger }), disabled: disabled !== null && disabled !== void 0 ? disabled : false, onClick: onClick, style: style, children: children }) }));
};
export default IconButton;
